import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SHELL_NS } from 'recruiter-i18n/namespaces/shell';
import { Alert, Anchor, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useSmsRegistrationDeadline } from 'hooks/useSmsRegistrationDeadline';
import { usePermissionsStore } from 'stores/permissionsStore';
import { buildPath, paths } from 'url-registry';
import { MainTabs, SubTabs } from 'utils/adminSettingsTabs';
import { getValidOrgId } from 'utils/storageUtils';

import classes from './SmsRegistrationDeadlineBanner.module.css';
import { getSmsRegistrationDeadlineDisplay } from './smsRegistrationDeadlineDisplay';

const SMS_REGISTRATION_PATH = buildPath(paths.SETTINGS_TAB, {
  main_tab: MainTabs.TELNYX_A2P_ONBOARDING,
  sub_tab: SubTabs.TELNYX_A2P_ONBOARDING,
});

/** App-wide notice while the org's SMS registration deadline is active or past. */
export const SmsRegistrationDeadlineBanner: React.FC = () => {
  const { t } = useTranslation(SHELL_NS);
  const orgId = getValidOrgId();
  const { deadline } = useSmsRegistrationDeadline(orgId);
  const isAdmin = usePermissionsStore((s) => s.isAdmin());
  const display = getSmsRegistrationDeadlineDisplay(deadline);

  if (!display) {
    return null;
  }

  return (
    <Alert
      icon={<IconAlertCircle size={24} />}
      title={display.title}
      color={display.tone === 'blocked' ? 'orange' : 'yellow'}
      m='sm'
      classNames={{ root: classes[display.tone] }}
    >
      <Text size='sm'>
        {display.message}{' '}
        {isAdmin ? (
          <Anchor component={Link} to={SMS_REGISTRATION_PATH} size='sm'>
            {t('smsDeadline.goToRegistration')}
          </Anchor>
        ) : (
          t('smsDeadline.askAdmin')
        )}
      </Text>
    </Alert>
  );
};
